export const calculatePercent = (fraction: number) => fraction * 100;
export const getPercentString = (percent: number) => `${percent}%`;
export const getPercentStringFromFraction = (fraction: number) =>
  getPercentString(calculatePercent(fraction));
export const numberToPixels = (value: number) => `${value}px`;
export const replaceDashWithSpace = (string: string) =>
  string.replace(/-/g, " ");
